<template>
	<section>
		<template
			v-for="(
				categoryPermission, categoryPermissionIndex
			) in permissionsListProp"
		>
			<div
				class="sub-category"
				:key="categoryPermissionIndex"
				v-if="showSubCategory(categoryPermission.category)"
			>
				<template
					v-for="(
						permission, permissionIndex
					) in categoryPermission.permissions"
				>
					<div
						:id="`permission-${permissionIndex}`"
						class="permission-item"
						:key="permissionIndex"
						v-if="canChangePermission(roleNameProp, permission.group)"
						@click="
							isReadOnlyPermission() ||
							canToggleGlobalAlertPreferences(permission.group)
								? ''
								: togglePermission(
										roleListIndexProp,
										categoryPermissionIndex,
										permissionIndex,
										categoryPermission,
								  )
						"
					>
						<span class="permission-name">{{ permission.groupName }}</span>
						<toggle-switch
							:class="permission.activeIndicator"
							v-model="permission.activeIndicator"
							:disabled="
								isReadOnlyPermission() ||
								canToggleGlobalAlertPreferences(permission.group)
							"
						>
						</toggle-switch>
					</div>
				</template>
			</div>
		</template>
	</section>
</template>

<script>
import ToggleSwitch from '@/components/global/ToggleSwitch.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
	name: 'PermissionsToggles',
	components: {
		ToggleSwitch,
	},
	props: {
		permissionsListProp: Array,
		roleListIndexProp: Number,
		roleNameProp: String,
	},
	computed: {
		...mapGetters([
			'canToggleGlobalAlertPreferences',
			'isReadOnlyPermission',
			'canChangePermission',
		]),
		...mapState({
			hasFambFeature: (state) => state.companyProfile.fambFeatureFlagIndicator,
		}),
	},
	methods: {
		...mapActions(['togglePermissionGroup']),
		// Must pass in the role list index, categoryPermissionIndex and permission index to drill down the layers and access isActive field
		togglePermission(
			roleListIndexProp,
			categoryPermissionIndex,
			permissionIndex,
			categoryPermission,
		) {
			this.togglePermissionGroup({
				roleListIndex: roleListIndexProp,
				categoryIndex: categoryPermissionIndex,
				permissionsIndex: permissionIndex,
				permission: categoryPermission,
			});
		},
		// TODO: Remove showSubCategory once the pilot flag for FindAMortgageBroker is removed.
		showSubCategory(subCategory) {
			if (subCategory === 'FindAMortgageBroker' && !this.hasFambFeature) {
				return false;
			}
			return true;
		},
	},
};
</script>

<style lang="scss" scoped>
.sub-category {
	.permission-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 0;
		height: 19px;
		border-bottom: $b360-border-width-thin solid $border-color-light;
	}

	&:last-child .permission-item:last-child {
		border-bottom: none;
	}

	.permission-name {
		color: $text-base-color;
		@include typo--roboto__regular;
		font-size: $b360-font-size--small;
		line-height: 1.5;

		@include mobile {
			font-size: $b360-font-size--smaller;
		}
	}

	.toggle-switch {
		&button {
			z-index: 99;
		}
	}
}
</style>
